import React,{useState} from 'react'
import './App.css'
var counting = 0;
const TicTacToe = (e) => {
    const [player1, setplayer1] = useState("");
    const [player2, setplayer2] = useState("");
    const [player,  setplayer] = useState(true);
    const [currplayer,setcurrplayer] = useState("");
    const [array, setarray] = useState([]);
    const [array2,setarray2] = useState([]);
    const [winner,setwinner] = useState(false);
    const [showbtn,setshowbtn] = useState(false);
    const [draw,setdraw] = useState(false);
    
    function handleinput(e) {
        
           counting = counting + 1;
            
           if(counting===9 && winner==='')
           {
               setdraw(true);
           }           
        console.log(`winner==${winner}`);

        setplayer(! player);
        if(player===true)
        {
            console.log(player1+" is playing");
            e.target.innerHTML = "0";
            setcurrplayer(player1);
            array.push(e.target.id);
        }
        else
        {
            console.log(player2+" is playing");
            e.target.innerHTML = "X";
            setcurrplayer(player2);
            array2.push(e.target.id);
        }
        
        document.getElementById(e.target.id).disabled = true;
        console.log("Tile no "+e.target.id+" was clicked");
  
        console.log(array);
        console.log(array2);
        

        const winningpossiblity = ["123","789","369","147","456","258","753","159",
                                //    "321","987","963","741","654","852","357","951"
                                ];
        
        // for(let i=0;i<winningpossiblity.length;i++)
        // {
        //     let str = (winningpossiblity[i]);            
        // }

        for(let i=0;i<=array.length-1;i++)
        {
            let first = array[i];
            for(let j=0;j<=array.length-1;j++)
            {
                let second = array[j];
                for(let k=0;k<=array.length-1;k++)
                {
                    let third = array[k];
                    if(first!==undefined && second !==undefined && third!==undefined)
                    {
                    let stringtest = (first.concat(second)).concat(third);
                    // let strreverse = (third.concat(second)).concat(first);
                    for(let x=0;x<=winningpossiblity.length-1;x++)
                    {
                        if(stringtest===winningpossiblity[x])
                        {
                            console.log("WIN");
                            
                            for(let q=1;q<=9;q++)
                            {
                                document.getElementById(q).disabled = true;
                            }
                            setwinner(true);
                            
                        }                  
                    }
                    console.log(stringtest);
                    }
                    
                }
            }
        }
        for(let i=0;i<=array2.length-1;i++)
        {
            let first = array2[i];
            for(let j=0;j<=array2.length-1;j++)
            {
                let second = array2[j];
                for(let k=0;k<=array2.length-1;k++)
                {
                    let third = array2[k];
                    if(first!==undefined && second !==undefined && third!==undefined)
                    {
                    let stringtest = (first.concat(second)).concat(third);
                    // let strreverse = (third.concat(second)).concat(first);

                    for(let x=0;x<=winningpossiblity.length-1;x++)
                    {
                        if(stringtest===winningpossiblity[x])
                        {
                            console.log("WIN");
                            
                            for(let q=1;q<=9;q++)
                            {
                                document.getElementById(q).disabled = true;
                            }
                            setwinner(true);   
                        }
                    }
                    // console.log(stringtest);
                    }
                    
                }
            }
        }
        

     

    }
    function resetGame()
    {
        for(let i=1;i<=9;i++)
        {
            document.getElementById(i).innerHTML='';
            document.getElementById(i).disabled = false;
        }
        setarray([]);
        setarray2([]);
        document.getElementById("idp1").value='';
        document.getElementById("idp2").value='';
        setcurrplayer("");
        setwinner("");
        setshowbtn(false);
        counting = 0;
        if(counting===9 && !winner)
        {
            setdraw(true)
        }
        else if(counting===9 && winner){
            setdraw(false)
        }
        if(winner)
        {
            setdraw(false)
        }
        
    }

    function ButtonsHandler(params) {
        setshowbtn(true);
    }
    return (
        <div>
            <h3>TIC TAC TOE</h3>
            <button onClick={ButtonsHandler}>START</button>
            <button onClick={resetGame}>RESET</button>
           {showbtn ? <div style={{marginBottom: "-3%",marginTop:"47px"}}>
            <input placeholder="Enter player 1 name" id="idp1" onChange={(e)=>{setplayer1(e.target.value)}} />
            <input placeholder="Enter player 2 name" id="idp2" onChange={(e)=>{setplayer2(e.target.value)}} />
           </div> : ""}
            {currplayer ? <div style={{marginTop:"6%",marginBottom:"-6%"}}>{currplayer} is playing now</div> : ""}
        {winner ? <h1 style={{marginTop:"8%",marginBottom:"-7%",transition:"ease-in-out"}}>{currplayer} WINS !!!</h1> : ""}
        {draw ? <h1 style={{marginTop:"8%",marginBottom:"-7%",transition:"ease-in-out"}}>MATCH DRAW !!! CLick RESET BUTTON</h1> : ""}
            <div className="container">
             <button id="1" onClick={handleinput} className="block"></button>
             <button id="2" onClick={handleinput} className="block"></button>
             <button id="3" onClick={handleinput} className="block"></button>
             <button id="4" onClick={handleinput} className="block"></button>
             <button id="5" onClick={handleinput} className="block"></button>
             <button id="6" onClick={handleinput} className="block"></button>
             <button id="7" onClick={handleinput} className="block"></button>
             <button id="8" onClick={handleinput} className="block"></button>
             <button id="9" onClick={handleinput} className="block"></button>
            </div>
        </div>
    )
}

export default TicTacToe
